import { formatReturn } from '@/ui/lib/quantFormat'
import type { Run } from './types'
import type { SignalTag } from '@/ui/SignalTerminal'
import { registerSessionReset } from '@/app/lib/sessionReset'

/*
 * Finish-line dedup (spec 036 T7.2). Several observers (the Quant shell's
 * list subscription, an open run detail, the Cancel handler) can all see the
 * same run end; one module-level pair of sets guarantees one Signal line per
 * `runId:status`, and only for a run we actually saw running (so loading old
 * history never logs).
 */
const seenRunning = new Set<string>()
const logged = new Set<string>()

type Emit = (tag: SignalTag, message: string) => void

export function observeRun(run: Run, emit: Emit): void {
  if (run.status === 'running') {
    seenRunning.add(run.id)
    return
  }
  if (!seenRunning.has(run.id)) return
  const key = `${run.id}:${run.status}`
  if (logged.has(key)) return
  logged.add(key)
  const exit = run.exit_code === null ? '' : ` - exit ${run.exit_code}`
  if (run.status === 'completed') emit('save', `Run ${run.id} completed${exit}, ${formatReturn(run.return_pct)}.`)
  else if (run.status === 'failed') emit('err', `Run ${run.id} failed${exit}${run.error ? ` - ${run.error}` : ''}.`)
  else if (run.status === 'canceled') emit('warn', `Run ${run.id} canceled${exit}.`)
  else if (run.status === 'orphaned') emit('warn', `Run ${run.id} orphaned.`)
}

export function resetRunFinish(): void {
  seenRunning.clear()
  logged.clear()
}

registerSessionReset(resetRunFinish)
